
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18582_whr0e_145",
  "child": "awsui_child_18582_whr0e_149",
  "horizontal": "awsui_horizontal_18582_whr0e_160",
  "horizontal-xxxs": "awsui_horizontal-xxxs_18582_whr0e_164",
  "horizontal-xxs": "awsui_horizontal-xxs_18582_whr0e_167",
  "horizontal-xs": "awsui_horizontal-xs_18582_whr0e_170",
  "horizontal-s": "awsui_horizontal-s_18582_whr0e_173",
  "horizontal-m": "awsui_horizontal-m_18582_whr0e_176",
  "horizontal-l": "awsui_horizontal-l_18582_whr0e_179",
  "horizontal-xl": "awsui_horizontal-xl_18582_whr0e_182",
  "horizontal-xxl": "awsui_horizontal-xxl_18582_whr0e_185",
  "vertical": "awsui_vertical_18582_whr0e_192",
  "vertical-xxxs": "awsui_vertical-xxxs_18582_whr0e_195",
  "vertical-xxs": "awsui_vertical-xxs_18582_whr0e_198",
  "vertical-xs": "awsui_vertical-xs_18582_whr0e_201",
  "vertical-s": "awsui_vertical-s_18582_whr0e_204",
  "vertical-m": "awsui_vertical-m_18582_whr0e_207",
  "vertical-l": "awsui_vertical-l_18582_whr0e_210",
  "vertical-xl": "awsui_vertical-xl_18582_whr0e_213",
  "vertical-xxl": "awsui_vertical-xxl_18582_whr0e_216",
  "align-center": "awsui_align-center_18582_whr0e_220",
  "align-start": "awsui_align-start_18582_whr0e_224",
  "align-end": "awsui_align-end_18582_whr0e_228"
};
  